import * as actionTypes from "../actions/actionTypes";

const initState = {
  sendingPostToDraft: false,
  draftPost: null,
  draftPostId: null,
  error: null,
};

const initSendPostAsDraft = (state, action) => {
  return {
    ...state,
    sendingPostToDraft: action.sendingPostToDraft,
  };
};

const successSendPostAsDraft = (state, action) => {
  return {
    ...state,
    sendingPostToDraft: action.sendingPostToDraft,
    draftPostId: action.draftPostId,
    draftPost: action.draftPost,
  };
};

const failSendPostAsDraft = (state, action) => {
  return {
    ...state,
    sendingPostToDraft: action.sendingPostToDraft,
    error: action.error,
  };
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.INIT_SEND_POST_AS_DRAFT:
      return initSendPostAsDraft(state, action);
    case actionTypes.SUCCESS_SEND_POST_AS_DRAFT:
      return successSendPostAsDraft(state, action);
    case actionTypes.FAIL_SEND_POST_AS_DRAFT:
      return failSendPostAsDraft(state, action);
    default:
      return state;
  }
};

export default Reducer;
